import { useCallback, useEffect, useMemo } from "react"

import MDBox from "components/MDBox"
import MDSelect from "components/MDSelect"

import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"

import { Role, getRoleCode } from "constant/Role"
import { useGetCenterListQuery } from "shared/redux/endpoints/admin"
import { useDispatch } from "react-redux"
import { setCenterId } from "shared/redux/slices/authSlice"
import { ToastUtil } from "utilities/toastUtil"
import "./home-default-center.scss"

export default function HomeDefaultCenter() {
  const auth = useSelector(selectAuth)
  const { data: centerList } = useGetCenterListQuery()
  const dispatch = useDispatch()

  const roleCode = getRoleCode(auth?.role)
  const isLxFamily = roleCode === Role.LXO || roleCode === Role.LX

  const centers = useMemo(
    () =>
      centerList?.data?.data?.map((center) => ({
        ...center,
        value: center.centerId,
        label: center.centerName,
      })) ?? [],
    [centerList]
  )

  const selectedCenter =
    centers.find((center) => center.value === auth.centerId) ?? null

  const handleCenterChange = useCallback(
    (e) => {
      dispatch(setCenterId({ centerId: e.value }))
      ToastUtil.showToastSuccess(`Center changed to ${e.label}`)
    },
    [dispatch]
  )

  // Switching into LX/LXO can leave `auth.centerId` pointing at no selectable
  // center — a teacher switching to LX carries over centerId 0, and a stored
  // center may not exist in this list — which renders the picker empty. Fall
  // back to the first center so a center is always pre-selected.
  useEffect(() => {
    if (!isLxFamily || centers.length === 0 || selectedCenter) return
    dispatch(setCenterId({ centerId: centers[0].value }))
  }, [isLxFamily, centers, selectedCenter, dispatch])

  // Teachers don't switch centers; every other role (including LX/LXO) gets
  // the picker, just rendered in a different position by the Sidenav.
  if (roleCode === Role.TEACHER) return null

  const defaultCenterSelectProps = {
    labelType: "sticky",
    labelText: "Center",
    isSearchable: false,
    options: centers,
    value: selectedCenter,
    name: "profile-default-center",
    onChange: (e) => handleCenterChange(e),
    className: "select-center",
  }

  return (
    <MDBox sx={{ mt: 1.5 }} className="home-default-center">
      <MDSelect size="small" {...defaultCenterSelectProps} />
    </MDBox>
  )
}
